import Vue from 'vue'
import FunctionalCalendar from 'vue-functional-calendar'
import { formatCalendarDate, getTodaysDate } from '../registration-form/date-helpers'
import Toast from '../toast'

// Date picker defaults:
Vue.use(FunctionalCalendar)

export default Vue.component(
  'registration-reports',
  {
    props: ['token'],
    data () {
      return {
        registrationDateObject: {}
      }
    },
    computed: {
      validRangeEntered () {
        return this.registrationDateObject.dateRange
      }
    },
    methods: {
      submit () {
        if (!this.validRangeEntered) {
          this.$toast.warning({
            component: Toast,
            props: {
              heading: 'Date range not valid',
              body: 'Please enter valid start and end dates before trying to generate report.'
            }
          })
        } else {
          let url = '/implanter/dashboard/generateReport?FormToken=' + this.token
          url += '&startDate=' + formatCalendarDate(this.registrationDateObject.dateRange?.start)
          url += '&endDate=' + formatCalendarDate(this.registrationDateObject.dateRange?.end)
          window.location = url
        }
      },
      getTodaysDate
    }
  }
)
